const base64urlToBuffer = (value) => {
	const base64 = String(value).replace(/-/g, "+").replace(/_/g, "/");
	const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
	const binary = atob(padded);
	const bytes = new Uint8Array(binary.length);
	for (let i = 0; i < binary.length; i += 1) {
		bytes[i] = binary.charCodeAt(i);
	}
	return bytes.buffer;
};

const bufferToBase64url = (buffer) => {
	const bytes = new Uint8Array(buffer);
	let binary = "";
	bytes.forEach((byte) => {
		binary += String.fromCharCode(byte);
	});
	return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

export const isPairingCode = (value) => /^[A-Za-z0-9]{4}-[A-Za-z0-9]{4}$/.test(String(value || ""));

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const fetchPasskeyOptionsWithRetry = async (api, whatsAppId, attempts = 5) => {
	let lastError;
	for (let i = 0; i < attempts; i += 1) {
		try {
			const { data } = await api.get(`/whatsappsession/${whatsAppId}/passkey`);
			if (data) return data;
		} catch (err) {
			lastError = err;
			if (i < attempts - 1) {
				await sleep(400);
			}
		}
	}
	throw lastError || new Error("Opções passkey indisponíveis.");
};

export const performPasskeyAssertion = async (publicKeyOptions) => {
	if (!window.PublicKeyCredential) {
		throw new Error("WebAuthn não é suportado neste navegador. Use Chrome ou Edge atualizado.");
	}

	if (!window.isSecureContext) {
		throw new Error("Passkey exige HTTPS (ou localhost). A plataforma precisa estar em contexto seguro.");
	}

	const options =
		typeof publicKeyOptions === "string" ? JSON.parse(publicKeyOptions) : publicKeyOptions;

	if (!options?.challenge || !options?.rpId) {
		throw new Error("Opções passkey inválidas recebidas do servidor.");
	}

	let credential;
	try {
		credential = await navigator.credentials.get({
			publicKey: {
				challenge: base64urlToBuffer(options.challenge),
				rpId: options.rpId,
				timeout: options.timeout || 60000,
				allowCredentials: (options.allowCredentials || []).map((item) => ({
					id: base64urlToBuffer(item.id),
					type: item.type || "public-key",
					transports: item.transports,
				})),
				userVerification: options.userVerification || "required",
			},
		});
	} catch (err) {
		if (err?.name === "SecurityError" || err?.name === "NotAllowedError") {
			throw new Error(
				"Não foi possível usar o passkey nesta página. Use Chrome/Edge, confirme que o passkey do WhatsApp Web está configurado neste navegador/perfil, e tente novamente."
			);
		}
		throw err;
	}

	if (!credential) {
		throw new Error("Nenhuma credencial passkey foi retornada.");
	}

	const assertion = credential.response;

	return {
		id: credential.id,
		rawId: bufferToBase64url(credential.rawId),
		type: credential.type,
		response: {
			clientDataJSON: bufferToBase64url(assertion.clientDataJSON),
			authenticatorData: bufferToBase64url(assertion.authenticatorData),
			signature: bufferToBase64url(assertion.signature),
			userHandle: assertion.userHandle ? bufferToBase64url(assertion.userHandle) : null,
		},
	};
};
